<template>
<div style="padding:20px 0;height:100%">
  <a-form-model
    size="small"
    ref="ruleForm"
    :model="form"
    :rules="rules"
    :label-col="labelCol"
    :validateOnRuleChange="true"
    :wrapper-col="wrapperCol"
  >
    <a-form-model-item label="分析来源" prop="analysisSource">
      <a-select v-model="form.analysisSource" @change="analysisSourceChange">
        <a-select-option v-for="(item,index) in source" :key="index" :value="index+1">{{item}}</a-select-option>
      </a-select>
    </a-form-model-item>
    <a-form-model-item label="适用下限" prop="minApply">
      <a-input-number :precision="3" :min="0.001" :step="0.001" size="small" :max="9999999999" style="width:100%"  placeholder="输入适用下限" v-model="form.minApply" />
    </a-form-model-item>
    <a-form-model-item label="适用上限" prop="maxApply">
      <a-input-number :precision="3" :step="0.001" size="small" :min="minApplyVal" :max="9999999999" style="width:100%" placeholder="输入适用上限" v-model="form.maxApply" />
    </a-form-model-item>
    <a-form-model-item label="梯度" prop="ladderVal">
      <a-input-number :precision="3" :disabled="!form.maxApply>0" size="small" :min="0.001" :max="9999999999" :step="0.001" style="width:100%"  placeholder="输入梯度" v-model="form.ladderVal" />
    </a-form-model-item>
  </a-form-model>
</div>
</template>

<script>
import { nhfMixins } from '../../untils'
export default {
  mixins:[nhfMixins],
  data(){
    return {
      source:['原料价格','原料用量'],
      form:{
        minApply:0
      },
      max:999999999,
      rules: {
        analysisSource: [{ required: true, message: '选择分析来源', trigger: 'change' }],
        maxApply: [{ required: true, message: '输入适用上限', trigger: 'change' }],
        minApply: [{ required: true, message: '输入适用下限', trigger: 'change' }],
        ladderVal: [{ required: true, validator:this.ladderValidator, trigger: 'change' }]
      },
    }
  },
  mounted(){
    const {id} = this.$route.query
    this.formulaId = id
    const {price,rawId} = this.rawRows[0]
    this.form = {
      ...this.form,
      formulaId: id,
      minApply:price === null ? price :  Number(price).toFixed(3),
      analysisSource:1,
      rawId
    }
  },
  computed:{
    minApplyVal(){
      return +this.form.minApply
    },
  },
 
  methods:{
     ladderValidator(rule, value, callback) {
      const {minApply,maxApply} = this.form
      if (value === '') {
        callback(new Error('请输入梯度'))
      } else if (value  > 100 && this.form.analysisSource == 2 ) {
        callback(new Error("原料用量梯度分析不能大于100"))
      } else if (minApply && minApply && ((maxApply - minApply) / value) >= 50) {
        callback(new Error("梯度数大于50，请重新设定"))
      } else {
        callback()
      }
    },
    
    analysisSourceChange(val){
      if(this.detail.length){
        const {price,percentage} = this.detail[0]
        this.rules.ladderVal.validator = val == 2 ?  this.preValidator : this.ladderValidator
        this.max = val == 1 ? 99999999 : 1
        this.form.minApply = val == 1 ?  (price ===null ? price : price.toFixed(3)) : (percentage ===null ? percentage :percentage.toFixed(3))
        // this.form.maxApply = null
        // this.form.ladderVal = null
      }
    },

    postAnalyse(){
      this.$refs.ruleForm.validate( valid => {
        if (valid) {
          const {form} = this
          let postArray = JSON.parse( JSON.stringify(form))
          if(this.form.analysisSource == 2) {
            postArray.minApply = this.div(postArray.minApply,100)
            postArray.maxApply = this.div(postArray.maxApply,100)
            postArray.ladderVal = this.div(postArray.ladderVal,100)
          }
       
          this.$emit('next',postArray)
        }
      })
    } 
  }
}
</script>
